import React, { useRef, useState } from 'react';
import { Loader, Dimmer, TableCell, TableRow, TableBody } from 'semantic-ui-react';
import Modal from 'react-bootstrap/Modal';
import axios from 'axios';
import {
  validaSoloNumero
} from '../util/varios';
import { Mensaje, MensajeSiNo } from '../components/mensajes';
import moment from 'moment';
import useTable from '../components/useTable';
import { ModalPermisosUsuarios } from '../components/almacen/modalPermisos';
import { ModalPermisosUsuariosv } from '../components/ventas/modalPermisosv';
import { ModalPermisosUsuariosc } from '../components/compra/modalPermisosc';
import { ModalPermisosUsuariosContabilidad } from '../components/contabilidad/modalPermisosContabilidad';
import { ModalPermisosUsuariosFinanzas } from '../components/finanzas/modalPermisosFinanzas';
import { ModalPermisosUsuarisVacios } from '../components/vacios/modalPermisosVacios';
import { ModalPermisosUsuarisServicios } from '../components/servicios/modalPermisosServicios';


export const CatPermisosUsuarios = (props) => {

  var op = require('../../public/modulos/datos');
  let token = sessionStorage.getItem('jwtToken');
  const fechasistema = JSON.parse(sessionStorage.getItem('fechasistema'));
  const afiliado = JSON.parse(sessionStorage.getItem("riforganizacion"));
  let idorganizacion = JSON.parse(sessionStorage.getItem("idorganizacion"));

  const headCells = [
    { id: '', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'CEDULA', textAlign: 'center' },
    { id: '', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'USUARIO', textAlign: 'center' },
    { id: 'opciones', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: ' OPCIONES', textAlign: 'center' }
  ]

  const btnCancela = useRef();
  const btnAcepta = useRef();
  const btnSalir = useRef();
  const txtTodasFechas = useRef();
  const txtBuscar = useRef();
  const txtTodosDispo = useRef();
  const txtCanceladas = useRef();
  const txtDeudas = useRef();
  const txtAnuladas = useRef();
  const txtTodosCliente = useRef();
  const txtPorCliente = useRef();
  const txtIdProducto = useRef();
  const txtRifrespon = useRef();
  const txtNomrespon = useRef();
  const txtDesde = useRef();
  const txtHasta = useRef();
  const txtCbmrif = useRef();
  const [filterFn, setFilterFn] = useState({ fn: items => { return items; } })
  const [inputalmacen, setInputalmacen] = useState(0);
  const [inputproducto, setInputproducto] = useState(0);
  const [tiporif, setTipofic] = useState(null);
  const [tituloc, setTituloc] = useState('');
  const [mostrar, setMostrar] = useState(false);
  const [operacion, setOperacion] = useState(0);
  const [persona, setPersona] = useState();
  const [usuario, setUsuario] = useState();
  const [records, setRecords] = useState([]);
  const [paracliente, setParacliente] = useState('');
  const [idclient, setIdclient] = useState('');
  const [report, setReport] = useState('');
  const [activate, setActivate] = useState(false);
  const [habilitado, setHabilitado] = useState(true);
  const [mensaje, setMensaje] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
  const [mensajesino, setMensajesino] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
  const [tituid, setTituid] = useState('');
  const [botones, setBotones] = useState({
    incluir: false,
    consultar: false,
    modificar: false,
    eliminar: false,
    aceptar: true,
    cancelar: true,
    catalogo: true,
    salir: false
  });

  const {
    TblContainer,
    TblHead,
    recordsAfterPagingAndSorting,
    TblPagination
  } = useTable(records, headCells, filterFn);

  const handleSearch = e => {
    let target = e.target;
    let st = '';
    setFilterFn({
      fn: items => {
        if (target.value === "")
          return items;
        else
          return items.filter(x => {
            if (x.persona.includes(target.value)
              || x.login.toLowerCase().includes(target.value.toLowerCase())
            ) {
              return x;
            }
          });
      }
    })

  }

  const seleccionarRegistros = () => {

    let define = "";

    if (props.nom === 'Inventario') {
      define = 'accinventario != ' + "'000000000000'";
    } else if (props.nom === 'Ventas') {
      define = 'accventas != ' + "'000000000'";
    } else if (props.nom === 'Compras') {
      define = 'acccompras != ' + "'00000'";
    } else if (props.nom === 'Contabilidad') {
      define = 'acccontabilidad != ' + "'000000'";
    } else if (props.nom === 'Finanzas') {
      define = 'accfinanzas != ' + "'00000000000'";
    } else if (props.nom === 'Vacios') {
      define = 'accvacios != ' + "'000000'";
    } else if (props.nom === 'Servicios') {
      define = 'accservicios != ' + "'0000000000'"
    }

    let endpoint = `${op.conexion}/api/athos/consulta/consultausuariospermi?&idorganizacion=${idorganizacion}&parameter=${define}`;

    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.length > 0) {
            setRecords(response.data);
            txtBuscar.current.focus();
          }
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      })
      .finally(() => {
        setActivate(false);
      });
  };

  const SelectUsuario = (idusuario) => {
    let endpoint = `${op.conexion}/api/athos/usuario/getuser?id=${idusuario}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then((response) => {
        if (response.status == 200) {
          if (response.data.idusuario > 0) {
            setPersona({
              cedula: response.data.cedula,
              nombres: response.data.nombres,
              apellidos: response.data.apellidos,
              correoe: response.data.correoe,
              tlf1: response.data.tlf1,
              tlf2: response.data.tlf2,
              fnacimiento: response.data.fnacimiento,
              nacionalidad: response.data.nacionalidad,
              sexo: response.data.sexo,
              direccion: response.data.direccion,
              nombreorg: response.data.nombreorg,
              idorganizacion: response.data.idorganizacion,
            });
            setUsuario(response.data);
            setMostrar(true);
          } else {
            setMensaje({
              mostrar: true,
              titulo: "Notificacion",
              texto: "Error al cargar el usuario",
              icono: "informacion",
            });
            setUsuario([]);
            setPersona([]);
            setActivate(false);
          }
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const blanquear = () => {
    setActivate(false);
    setInputalmacen(0);
    setRecords([]);
    setParacliente('');
    setInputproducto(0);
    setReport('');
    setIdclient('');
  }

  const cancelar = () => {
    blanquear();
    props.onHideCancela();

  };

  const handleCloseSi = () => {
    setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });

  };

  const cerrarModal = () => {
    if (props.llamado === 2) {
      props.onHideRenderizar();
      props.onHideCancela();
    }
    blanquear();
    setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
  }


  const gestionarUsuarios = (op, item) => (e) => {
    e.preventDefault();

    if (op === 1) {
      setOperacion(op);
      SelectUsuario(item.idusuario);
    }

  };

  const cerrarModalActualizar = () => {
    setMostrar(false);
    seleccionarRegistros();
  };

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      keyboard={false}
      onShow={() => {

        if (props.op === 1) {
          seleccionarRegistros();
          txtBuscar.current.focus();
          setHabilitado(false);
        } else {

          setHabilitado(true);
        }

      }}
    >
      <Modal.Header className='azulGradiant2 header-modal'>
        <div className='fw-bold' style={{ color: "#fff" }}><h3>Permisos de Usuario</h3></div>

        <a href='#' ref={btnSalir} disabled={botones.salir} onClick={cancelar} className='text-light' ><i className="fas fa-times fa-1x shadow" > {/* Salir */}</i></a>

      </Modal.Header>
      <Modal.Body style={{ backgroundColor: "#FFF" }}>
        <Mensaje mensaje={mensaje}
          onHide={() => {
            mensaje.titulo === 'Exito.' ?
              cerrarModal() :
              setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })
          }
          } />
        <MensajeSiNo mensaje={mensajesino}
          onHideNo={() => setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' })} onHideSi={handleCloseSi} />

        {props.nom === 'Inventario' ? <ModalPermisosUsuarios
          show={mostrar}
          op={operacion}
          usuario={usuario}
          persona={persona}
          onHideCancela={cerrarModalActualizar}
        /> : props.nom === 'Ventas' ? <ModalPermisosUsuariosv
          show={mostrar}
          op={operacion}
          usuario={usuario}
          persona={persona}
          onHideCancela={cerrarModalActualizar}
        /> : props.nom === 'Compras' ? <ModalPermisosUsuariosc
          show={mostrar}
          op={operacion}
          usuario={usuario}
          persona={persona}
          onHideCancela={cerrarModalActualizar}
        /> : props.nom === 'Contabilidad' ? <ModalPermisosUsuariosContabilidad
          show={mostrar}
          op={operacion}
          usuario={usuario}
          persona={persona}
          onHideCancela={cerrarModalActualizar}
        /> : props.nom === 'Finanzas' ? <ModalPermisosUsuariosFinanzas
          show={mostrar}
          op={operacion}
          usuario={usuario}
          persona={persona}
          onHideCancela={cerrarModalActualizar}
        /> : props.nom === 'Vacios' ? <ModalPermisosUsuarisVacios
        show={mostrar}
        op={operacion}
        usuario={usuario}
        persona={persona}
        onHideCancela={cerrarModalActualizar}
      /> : props.nom === 'Servicios' ? <ModalPermisosUsuarisServicios
      show={mostrar}
      op={operacion}
      usuario={usuario}
      persona={persona}
      onHideCancela={cerrarModalActualizar}
    />  : ''}

        <Dimmer active={activate} inverted>
          <Loader inverted>cargando...</Loader>
        </Dimmer>
        <div className='col-md-12 row mx-auto px-0'>

          <div className="row col-md-12 rounded mx-auto">

            <fieldset className='row col-sm-12 mx-auto border-azul rounded mb-1'>
              <legend className="float-none m-0 w-auto fs-4 fw-bold">Usuarios Autorizados({props.nom === 'Inventario' ? 'Almacen' : props.nom})</legend>

              <div className='col-pd-250 px-2 mb-1'>
                <input type="text" ref={txtBuscar} className="form-control form-control-sm rounded-pill border-azul text-uppercase" onChange={handleSearch} placeholder="BUSCAR" />
              </div>

              <div className="col-md-12" style={{ margin: "auto" }} >
                <TblContainer>
                  <TblHead />
                  <TableBody >
                    {
                      records && recordsAfterPagingAndSorting().map((item, index) => (
                        <TableRow key={index} style={{ padding: "0" }}>
                          <TableCell className='align-baseline' style={{ textAlign: "center", alignItems: 'center' }}>{item.persona}</TableCell>
                          <TableCell className='align-baseline' style={{ textAlign: "center", alignItems: 'center', width: '270px' }}>{item.login}</TableCell>
                          <TableCell className='align-baseline' style={{ textAlign: "center", alignItems: 'center' }}>
                            <button onClick={gestionarUsuarios(1, item)} className="btn btn-sm mx-1 btn-warning rounded-circle"><i className="fa fa-edit"></i> </button>
                          </TableCell>
                        </TableRow>
                      ))
                    }
                  </TableBody>
                </TblContainer>
                <TblPagination />
              </div>

            </fieldset>

          </div>

        </div>
      </Modal.Body >
      <Modal.Footer>
        <div className="row m-0 col-md-12 mx-auto">

          <div className='col-md-4 ml-auto px-0 m-0 d-flex justify-content-end'>
            <button ref={btnCancela} onClick={cancelar} className="btn btn-danger btn-sm rounded-pill mx-1"><i className="fas fa-window-close"> Cancelar</i></button>
          </div>
        </div>

      </Modal.Footer>

    </Modal >
  );
}




// WEBPACK FOOTER //
// ./src/catalogos/modalPermisosusuario.js